import { createAction, handleActions } from 'redux-actions';
import update from 'immutability-helper';

import UserService from 'scripts/services/UserService';

const BUSINESS_DETAILS = 'scripts/account/BUSINESS_DETAILS';

export const smsfDetails = createAction(BUSINESS_DETAILS);


export function fetchBusinessDetails() {
  return async function (dispatch, getState) {
    const { user } = getState();
    if (user.loggedIn) {
      const payload = await UserService.getBusinessDetails(user.id);
      return dispatch(smsfDetails(payload));
    }
  };
}

const reducer = handleActions({
  [BUSINESS_DETAILS]: (state, action) => update(state, {
    $set: action.payload
  }),
}, null);

export default reducer;
